type ProfileFieldProps = {
  title: string;
  value: string;
};

export function ProfileField({ title, value }: ProfileFieldProps) {
  return (
    <div className="tw:mb-4">
      <p className="tw:mb-1 tw:text-sm tw:font-bold">{title}</p>
      <p className="tw:text-sm tw:break-all">{value}</p>
    </div>
  );
}
